export default "__VITE_ASSET__1f31db84__"